<template>
  <div>
    <button
        class="btn px-2 mr-1"
        :class="servicioSelected.is_orden_trabajo ? 'btn-success' : 'btn-light'"
        :disabled="disabled"
        @click="openModalOrdenTrabajo(id)"
        >
        O.T
    </button>
    <b-modal
      :id="'modal-orden-trabajo-'+id"
      header-class="bg-orange d-block"
      hide-footer>
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <h5 class="mb-0"><span style="color: white; font-weight: bold;">Orden de Trabajo</span></h5>
          <button type="button" class="close text-white" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <b-container fluid class="mb-5">
        <b-row class="">
          <b-col>
            <b-button
              :variant="tipoOpcionProfesional ? 'success' : 'outline-secondary'"
              block
              @click="selectTipoOpcion(TIPO_OPCION_OT.PROFESIONAL)">
              Trabajo Individual
            </b-button>
          </b-col>
          <b-col>
            <b-button
              :variant="tipoOpcionGrupo ? 'success' : 'outline-secondary'"
              block
              @click="selectTipoOpcion(TIPO_OPCION_OT.GRUPO)">
              Trabajo Grupal
            </b-button>
            <small class="text-muted d-block text-center">Laboratorio</small>
          </b-col>
        </b-row>
        <div class="mt-3 mb-4" v-if="opcion === TIPO_OPCION_OT.PROFESIONAL">
          <multiselect
            v-model="profesionalSelecteds"
            :options="profesionales"
            placeholder=""
            selectedLabel=""
            label="nombre"
            track-by="id"
            select-label=""
            deselect-label="X"
            multiple
          >
        </multiselect>
        </div>
      </b-container>
      <div class="d-flex justify-content-end mt-3 px-3 pb-0">
        <b-button variant="outline-secondary" class="mr-2 py-1" @click="cerrarModal()">Cancelar</b-button>
        <b-button variant="success" class="py-1" @click="guardar">Guardar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { TIPO_OPCION_OT } from '@/utils/globalConventions';

export default {
  name: 'ModalOrdenTrabajo',
  components: {
    Multiselect,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    servicioId: {
      required: true,
    },
    isOrdenTrabajo: {
      type: Boolean,
      default: false,
    },
    servicioSelected: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TIPO_OPCION_OT,
    };
  },
  methods: {
    openModalOrdenTrabajo(index) {
      // cargarRegistroParaModal
      this.setModalOrdenTrabajo(index);
    },
    reset() {
      console.log('reset modal orden de trabajo');
    },
    guardar() {
      this.isGuardar = true;
      // guardar el id del medico o grupo seleccionado
      const medicos = [];
      this.profesionalSelecteds.forEach((element) => {
        medicos.push(element.id);
      });
      const DATA = {
        estado: true,
        is_orden_trabajo: true,
        tipo_id: this.opcion,
        orden_trabajo_medicos_id: medicos,
      };
      this.$emit('getDataOrdenTrabajo', DATA);
      this.cerrarModal();
    },
    cerrarModal() {
      this.$bvModal.hide(`modal-orden-trabajo-${this.id}`);
    },
    selectTipoOpcion(opcion) {
      this.profesionalSelecteds = [];
      this.opcion = opcion;
      const DATA = {
        tipoGrupo: this.opcion,
        servicioId: this.servicioId,
      };
      this.medicoOrdenTrabajo(DATA);
    },
    ...mapActions('modalOrdenTrabajo', [
      'medicoOrdenTrabajo',
    ]),
    async setModalOrdenTrabajo(index) {
      if (this.isOrdenTrabajo) {
        // tiene datos guardados recuperar esos datos
        this.opcion = this.servicioSelected.tipo_id;
        const DATA = {
          tipoGrupo: this.opcion,
          servicioId: this.servicioId,
        };
        await this.medicoOrdenTrabajo(DATA);
        this.profesionalSelecteds = this.profesionales.filter((prof) => this.servicioSelected.orden_trabajo_medicos_id.includes(prof.id));
      } else {
        this.opcion = null;
        this.profesionalSelecteds = [];
      }
      this.$bvModal.show(`modal-orden-trabajo-${index}`);
    },
  },
  computed: {
    ...mapState('modalOrdenTrabajo', [
      'profesionales',
    ]),
    ...mapFields('modalOrdenTrabajo', [
      'estado',
      'isGuardar',
      'opcion',
      'profesionalSelecteds',
    ]),
    tipoOpcionProfesional() {
      return this.opcion === TIPO_OPCION_OT.PROFESIONAL;
    },
    tipoOpcionGrupo() {
      return this.opcion === TIPO_OPCION_OT.GRUPO;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
.header-color {
  background-color: #6c2eb9; /* tu color propio (morado en este ejemplo) */
}

</style>
